import { WorkItem } from './types';
// Import all master data from single source
import { 
  departments, 
  stages, 
  workItemTemplates,
  stageColors,
  priorityColors,
  statusColors,
  orders  // Import unified orders
} from './masterData';

// Re-export for backward compatibility
export { departments, stages, workItemTemplates, stageColors, priorityColors, statusColors, orders };

// 3️⃣ WorkItems Data  ────────────────────────────────────────────
export const workItems: WorkItem[] = [
  // 採購部工作項目
  {
    id: "WORK-001",
    orderId: "ORD-001",
    department: "採購部",
    title: "採購軸心",
    description: "依規格採購鐵輪軸心",
    date: "2025-07-19",
    startTime: "09:00",
    endTime: "11:00",
    assignedWorkers: ["陳採購", "李助理"],
    status: "in-progress",
    priority: "high",
    stage: "material-preparation",
    estimatedHours: 2,
    notes: "需要確認軸心規格和供應商交期"
  },
  {
    id: "WORK-002", 
    orderId: "ORD-001",
    department: "採購部",
    title: "採購原料",
    description: "採購橡膠與化學藥劑原料",
    date: "2025-07-20",
    startTime: "14:00",
    endTime: "16:00",
    assignedWorkers: ["陳採購"],
    status: "pending",
    priority: "medium",
    stage: "production",
    estimatedHours: 2,
    notes: "等待軸心採購確認後進行"
  },

  // 包膠部工作項目
  {
    id: "WORK-003",
    orderId: "ORD-002", 
    department: "包膠部",
    title: "舊輪除膠",
    description: "去除舊輪殘膠",
    date: "2025-07-19",
    startTime: "08:00",
    endTime: "10:00",
    assignedWorkers: ["王師傅", "林作業員"],
    status: "in-progress",
    priority: "high",
    stage: "material-preparation",
    estimatedHours: 2,
    notes: "舊輪狀況良好，預計2小時完成"
  },
  {
    id: "WORK-004",
    orderId: "ORD-002",
    department: "包膠部", 
    title: "鐵輪除鏽",
    description: "清除鐵輪鏽蝕",
    date: "2025-07-19",
    startTime: "10:00",
    endTime: "12:00",
    assignedWorkers: ["王師傅"],
    status: "pending",
    priority: "high",
    stage: "production",
    estimatedHours: 2,
    notes: "等待除膠完成"
  },
  {
    id: "WORK-005",
    orderId: "ORD-002",
    department: "包膠部",
    title: "包膠",
    description: "將橡膠片纏繞包覆輪芯",
    date: "2025-07-20",
    startTime: "09:00",
    endTime: "15:00",
    assignedWorkers: ["張師傅", "李師傅"],
    status: "pending",
    priority: "high",
    stage: "production", 
    estimatedHours: 6,
    notes: "需要兩位師傅協作完成"
  },

  // 車床部工作項目
  {
    id: "WORK-006",
    orderId: "ORD-003",
    department: "車床部",
    title: "粗車",
    description: "粗加工去除多餘材料",
    date: "2025-07-19",
    startTime: "09:00",
    endTime: "17:00",
    assignedWorkers: ["黃師傅"],
    status: "completed",
    priority: "high",
    stage: "production",
    estimatedHours: 8,
    actualHours: 7.5,
    notes: "粗車完成，尺寸符合要求"
  },
  {
    id: "WORK-007",
    orderId: "ORD-003",
    department: "車床部",
    title: "研磨", 
    description: "初步研磨表面",
    date: "2025-07-20",
    startTime: "08:00",
    endTime: "12:00",
    assignedWorkers: ["黃師傅", "吳技師"],
    status: "in-progress",
    priority: "high",
    stage: "production",
    estimatedHours: 4,
    notes: "研磨進行中，預計中午完成"
  },

  // 品管部工作項目
  {
    id: "WORK-008",
    orderId: "ORD-004",
    department: "品管部",
    title: "檢驗尺寸",
    description: "比對圖面進行尺寸檢驗",
    date: "2025-07-19",
    startTime: "13:00",
    endTime: "16:00",
    assignedWorkers: ["鄭檢驗員"],
    status: "in-progress",
    priority: "medium",
    stage: "production",
    estimatedHours: 3,
    notes: "使用精密測量設備檢驗"
  },
  {
    id: "WORK-009",
    orderId: "ORD-004",
    department: "品管部",
    title: "檢驗外觀",
    description: "檢查外觀缺陷與瑕疵",
    date: "2025-07-20",
    startTime: "09:00",
    endTime: "11:00",
    assignedWorkers: ["劉檢驗員"],
    status: "pending",
    priority: "medium",
    stage: "production",
    estimatedHours: 2,
    notes: "等待尺寸檢驗完成"
  },

  // 更多包膠部工序
  {
    id: "WORK-010",
    orderId: "ORD-005",
    department: "包膠部",
    title: "鐵輪上藥劑",
    description: "塗佈黏著劑／底漆",
    date: "2025-07-19",
    startTime: "13:00",
    endTime: "15:00",
    assignedWorkers: ["張師傅", "周作業員"],
    status: "in-progress",
    priority: "high",
    stage: "material-preparation",
    estimatedHours: 2,
    notes: "底漆塗佈中，需確保均勻覆蓋"
  },
  {
    id: "WORK-011",
    orderId: "ORD-005",
    department: "包膠部",
    title: "出片",
    description: "橡膠片裁切／預成型",
    date: "2025-07-19",
    startTime: "15:00",
    endTime: "17:00",
    assignedWorkers: ["李作業員"],
    status: "pending",
    priority: "medium",
    stage: "production",
    estimatedHours: 2,
    notes: "等待藥劑乾燥完成"
  },
  {
    id: "WORK-012",
    orderId: "ORD-005",
    department: "包膠部",
    title: "束布",
    description: "纏束強化布層",
    date: "2025-07-20",
    startTime: "10:00",
    endTime: "12:00",
    assignedWorkers: ["王師傅"],
    status: "pending",
    priority: "medium",
    stage: "production",
    estimatedHours: 2,
    notes: "等待包膠完成"
  },
  {
    id: "WORK-013",
    orderId: "ORD-005",
    department: "包膠部",
    title: "加硫",
    description: "熱壓硫化固化橡膠",
    date: "2025-07-20",
    startTime: "13:00",
    endTime: "17:00",
    assignedWorkers: ["張師傅", "周作業員"],
    status: "pending",
    priority: "high",
    stage: "production",
    estimatedHours: 4,
    notes: "硫化溫度需控制在160-180°C"
  },

  // 車床部更多工序
  {
    id: "WORK-014",
    orderId: "ORD-006",
    department: "車床部",
    title: "細處理",
    description: "細磨達到尺寸精度",
    date: "2025-07-19",
    startTime: "13:00",
    endTime: "17:00",
    assignedWorkers: ["吳師傅"],
    status: "in-progress",
    priority: "high",
    stage: "production",
    estimatedHours: 4,
    notes: "目前精度已達到±0.05mm"
  },
  {
    id: "WORK-015",
    orderId: "ORD-006",
    department: "車床部",
    title: "特殊處理",
    description: "依客戶需求之特殊加工",
    date: "2025-07-20",
    startTime: "08:00",
    endTime: "12:00",
    assignedWorkers: ["吳師傅", "陳技師"],
    status: "pending",
    priority: "medium",
    stage: "production",
    estimatedHours: 4,
    notes: "客戶要求特殊溝槽加工"
  },

  // 品管部更多工序
  {
    id: "WORK-016",
    orderId: "ORD-007",
    department: "品管部",
    title: "量測數據報告",
    description: "整理量測結果並生成報告",
    date: "2025-07-19",
    startTime: "16:00",
    endTime: "18:00",
    assignedWorkers: ["劉檢驗員"],
    status: "pending",
    priority: "medium",
    stage: "production",
    estimatedHours: 2,
    notes: "需要完成20個樣品的檢驗報告"
  },
  {
    id: "WORK-017",
    orderId: "ORD-007",
    department: "品管部",
    title: "打出貨標籤",
    description: "列印並貼附出貨標籤",
    date: "2025-07-20",
    startTime: "14:00",
    endTime: "15:00",
    assignedWorkers: ["黃助理"],
    status: "pending",
    priority: "low",
    stage: "production",
    estimatedHours: 1,
    notes: "等待檢驗完成後標籤列印"
  },

  // 倉庫部工作項目
  {
    id: "WORK-018",
    orderId: "ORD-008",
    department: "倉庫部",
    title: "進貨",
    description: "接收原料／零件進庫",
    date: "2025-07-19",
    startTime: "08:00",
    endTime: "10:00",
    assignedWorkers: ["鄭管理員", "謝助理"],
    status: "completed",
    priority: "high",
    stage: "production",
    estimatedHours: 2,
    notes: "橡膠原料已完成進貨檢驗"
  },
  {
    id: "WORK-019",
    orderId: "ORD-008",
    department: "倉庫部",
    title: "過濾",
    description: "原料雜質過濾／分級",
    date: "2025-07-19",
    startTime: "10:00",
    endTime: "12:00",
    assignedWorkers: ["謝助理"],
    status: "in-progress",
    priority: "medium",
    stage: "production",
    estimatedHours: 2,
    notes: "橡膠原料過濾中，雜質含量正常"
  },
  {
    id: "WORK-020",
    orderId: "ORD-009",
    department: "倉庫部",
    title: "出貨",
    description: "成品出庫／物流安排",
    date: "2025-07-20",
    startTime: "13:00",
    endTime: "16:00",
    assignedWorkers: ["鄭管理員", "李助理"],
    status: "pending",
    priority: "high",
    stage: "shipping",
    estimatedHours: 3,
    notes: "等待包裝完成後安排物流"
  },

  // 包裝部工作項目
  {
    id: "WORK-021",
    orderId: "ORD-009",
    department: "包裝部",
    title: "清潔",
    description: "最終清潔與去除粉塵",
    date: "2025-07-19",
    startTime: "16:00",
    endTime: "17:00",
    assignedWorkers: ["高包裝員"],
    status: "in-progress",
    priority: "medium",
    stage: "production",
    estimatedHours: 1,
    notes: "使用壓縮空氣清潔輪胎表面"
  },
  {
    id: "WORK-022",
    orderId: "ORD-009",
    department: "包裝部",
    title: "包裝",
    description: "包裝並封裝成品",
    date: "2025-07-20",
    startTime: "09:00",
    endTime: "12:00",
    assignedWorkers: ["高包裝員", "葉助理"],
    status: "pending",
    priority: "high",
    stage: "production",
    estimatedHours: 3,
    notes: "使用防震包材，確保運輸安全"
  }
];
